import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../services/AuthContext";
import { Link, useNavigate } from "react-router-dom";

import {
  userAndAuthorsListByUserId,
  userAndPublishersListByUserId,
} from "../../../services/userpanelservice";

// Kayıt tarihini Türkçe formatlamak için yardımcı
function formatDateTR(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  return date.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export default function InstructorSidebar() {
  const { auth, setAuth } = useContext(AppContext);
  const navigate = useNavigate();

  const defaultAvatar = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23E5E7EB'/%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-4.42 0-8 3.58-8 8v2h16v-2c0-4.42-3.58-8-8-8z' fill='lightgray'/%3E%3C/svg%3E";

  const [hasAuthors, setHasAuthors] = useState(false);
  const [hasPublishers, setHasPublishers] = useState(false);
  const [loadingPanelFlags, setLoadingPanelFlags] = useState(true);

  const panelBase =
    process.env.REACT_APP_PANEL_BASE || `${window.location.origin}`;

  const links = [
    { label: "Kullanıcı Paneli", href: `${panelBase}/panel/user`, icon: "bx bx-home" },
    { label: "Favori Yayınlarım", href: `${panelBase}/panel/user/userpublications`, icon: "bx bx-folder" },
    { label: "Kaydedilen Aramalarım", href: `${panelBase}/panel/user/savedqueries`, icon: "bx bx-search" },
    { label: "Aboneliklerim", href: `${panelBase}/panel/user/subscription`, icon: "bx bx-cube" },
  ];

  const dataHasItems = (data) => {
    if (!data) return false;
    if (Array.isArray(data)) return data.length > 0;
    if (typeof data === "object") {
      if (Array.isArray(data.data) && data.data.length > 0) return true;
      if (Array.isArray(data.authors) && data.authors.length > 0) return true;
      if (Array.isArray(data.publishers) && data.publishers.length > 0) return true;
      for (const key of Object.keys(data)) {
        if (Array.isArray(data[key]) && data[key].length > 0) return true;
      }
    }
    return false;
  };

  useEffect(() => {
    let mounted = true;
    const token = auth?.token || auth?.accessToken || null;

    const load = async () => {
      setLoadingPanelFlags(true);
      if (!token) {
        if (mounted) setLoadingPanelFlags(false);
        return;
      }

      try {
        const [authorsResp, publishersResp] = await Promise.all([
          userAndAuthorsListByUserId(token).catch(() => null),
          userAndPublishersListByUserId(token).catch(() => null),
        ]);

        if (!mounted) return;

        setHasAuthors(dataHasItems(authorsResp));
        setHasPublishers(dataHasItems(publishersResp));
      } catch {
        setHasAuthors(false);
        setHasPublishers(false);
      } finally {
        if (mounted) setLoadingPanelFlags(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, [auth]);

  const handleLogout = () => {
    setAuth({
      token: "",
      id: "",
      title: "",
      name: "",
      surname: "",
      email: "",
      telephone: "",
      address: "",
      regdate: "",
      tc: "",
      regstatus: "",
      mobileuser: "",
      updatedate: "",
      rolename: "",
    });
    sessionStorage.removeItem("auth");
    navigate("/login");
  };

  const isPublisher = auth?.rolename === "PUBLISHER";

  return (
    <div className="bg-white rounded-4 shadow-sm p-4 text-center">
      <div className="mb-3">
        <img
          src={auth.avatarUrl || defaultAvatar}
          alt="Profil"
          className="rounded-circle border"
          style={{ width: 120, height: 120, objectFit: "cover" }}
          onError={(e) => {
            e.currentTarget.src = defaultAvatar;
          }}
        />
      </div>

      <h4 className="fw-semibold mb-1 text-newdarkfume">{auth?.name || "-"}</h4>
      <div className="text-darkfume mb-2">{auth?.email || ""}</div>
      <div
        className="text-fume mb-3 border-bottom pb-3"
        style={{ fontSize: "0.95em" }}
      >
        Kayıt Tarihi: {formatDateTR(auth?.regdate)}
      </div>

      {/* Menü */}
      {/* {!isPublisher && (
        <ul className="list-unstyled text-start mb-3">
          {links.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center py-2 text-darkfume"
              >
                <i className={`${item.icon} me-2`} />
                {item.label}
              </a>
            </li>
          ))}

          {!loadingPanelFlags && (hasAuthors || (!hasAuthors && !hasPublishers)) && (
            <li>
              <a
                href={`${panelBase}/panel/user/searchprofile`}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center py-2 text-darkfume"
              >
                <i className={`bx bx-user me-2`} />
                Yazar Profilim
              </a>
            </li>
          )}

          {!loadingPanelFlags && (hasPublishers || (!hasAuthors && !hasPublishers)) && (
            <li>
              <a
                href={`${panelBase}/panel/user/searchpublisher`}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center py-2 text-darkfume"
              >
                <i className={`bx bx-buildings me-2`} />
                Yayınevlerim
              </a>
            </li>
          )}
        </ul>
      )} */}

      {/* Alt aksiyonlar (herkes için görünür) */}
      <ul className="list-unstyled text-start">
        <li>
          <Link
            to="/profile-settings"
            className="d-flex align-items-center py-2 text-darkfume"
          >
            <i className="bx bxs-cog me-2"></i> Kullanıcı Ayarları
          </Link>
        </li>
        <li>
          <button
            className="d-flex align-items-center py-2 text-darkfume border-0 bg-white p-0"
            onClick={handleLogout}
          >
            <i className="bx bxs-log-out me-2"></i> Çıkış Yap
          </button>
        </li>
      </ul>
    </div>
  );
}
